import enLocale from 'element-ui/lib/locale/lang/en'
export default {
  ...enLocale,
  title:'Customer service platform',
  login: {
    namePlaceholder:'Please enter user name',
    passwordPlaceholder: 'Please enter password',
    remember: 'Remember the password',
    btn: 'Log on',
    btnTip:'Logging in',
    nameTip:'User name cannot be empty',
    passwordTip:'password cannot be empty',
    passwordLength:'The maximum password length is 16 bits',
    noMatch:'The confirmed password does not match the new password',
    loading: 'Loading...',
    checkMFA: 'Verifying MFA...'
  },
  header:{
    outBtn:'Exit',
    setBtn:'Set up',
    changeBtn:'Update Password',
    openMfa: 'Open ',
    closeMfa: 'Close ',
  },
  pwd: {
    oldPwd: 'Original password',
    newPwd: 'New password',
    confirmPwd: 'Confirm password',
    oldPwdTip: 'The original password cannot be empty',
    newPwdTip: 'The new password cannot be empty',
    confirmPwdTip: 'Confirm password cannot be empty',
    passwordTip: 'The password must be 8-16 digits, including letters, numbers, and special characters (- _! @ # $)',
    noMatch: 'The confirmed password does not match the new password',
    success: 'Password modification successful, please log in again!',
    btn: 'Modify',
    btnTip: 'Under modification',
    reset:  'Reset',
  },
  common:{
    precharge: 'precharge',
    create: ' create ',
    history: ' history ',
    back: 'back',
    logType:'log type',
    keyword:'keyword',
    input:'Please input ',
    operate:'operate ',
    memo:'note',
    time:'time',
    account:'account ',
    botAccount:'bot account',
    select:'Please select ',
    startDate:'start date',
    endDate:'end date',
    and:'and',
    additionalCost: 'Additional Cost',
    offsetExpenses: 'Offset expenses',
    payAmount: 'Pay Amount',
    taxation: 'taxation ',
    text: 'text ',
    status:'status',
    content:'content',
    site:'site',
    name:'name',
    nickname:'nickname',
    description:'description',
    invitationLink:'invitation link',
    confirmDay: 'settlement interval',
    default: 'default ',
    memberRefundProp: 'Member account consumption rebate',
    day: 'day',
    wallet:'wallet ',
    address:'address',
    batch:'batch ',
    startMonth:'Month of commencement',
    endMonth:'End of month',
    customer:'customer ',
    agent:'agent',
    messageType: 'message type',
    sendTime: 'send time',
    sendType: 'send type',
    noticeContent:'notice content',
    email:'email',
    type:'type',
    tableTime:'creation/modification time',
    all:'all',
    prepaid:'prepaid ',
    agreed:'agreed ',
    phone:'phone',
    actualAmount:'actual amount',
    actualTotalAmount:'Total amount received',
    receivableTotalAmount:'Total amount receivable',
    date: 'date',
    range: ' range',
    payment:'payment ',
    receipt:'receipt ',
    amount:' amount ',
    amountTo:'amount to',
    bill:'bill ',
    total:'total ',
    accounting:'accounting',
    audit:'audit ',
    operator:'operator',
    member: 'member',
    quantity: ' number',
    quota: ' quota',
    available: 'available',
    table: ' table',
    join: 'join ',
    leave: 'leave ',
    method: 'method',
    month: ' month',
    service: 'service ',
    currency: 'currency',
    unit: ' unit',
    cost: ' cost',
    other: ' other ',
    summary: ' summary ',
    contacts: 'contacts',
    level: 'level',
    code: 'code',
    region: 'region ',
    year:'year',
    week:'week',
    strategy: 'strategy',
    hanwei:'hanwei',
    picture:'图像',
    alias: ' alias',
    label: 'label',
    tag: ' tag ',
    min: 'min ',
    max: 'max ',
    monthly: 'monthly',
    value: 'value',
    staff: 'staff ',
    attribution: 'attribution ',
    login: 'login ',
    generate: 'generate ',
    group: 'group ',
    discountRate: 'discount rate',
    scale: 'scale ',
    nonCDN: 'Non CDN resources',
    manage: ' manage ',
    role: 'role ',
    password: 'password',
    avatar: 'avatar',
    way: 'way',
    option: 'option',
    increase: 'increase ',
    association: 'association ',
    execute: 'execute ',
    update: 'update ',
    version: 'version',
    salt: 'salt',
    root: 'root ',
    // directory: 'directory ',
    company: 'company ',
    taxID: 'tax number',
    bank: 'bank ',
    prefix: 'prefix ',
    title: ' title',
    system: 'system ',
    tip: 'Tip ',
    sender: 'sender',
    function: 'function ',
    result: 'result ',
    fail: 'fail ',
    success: 'success ',
    user: 'user ',
    parentLevel: 'Parent level',
    noParent: ' No parent',
    discounts: 'discounts ',
    discount: 'discount ',
    afterDiscount: 'After discount ',
    USDToRMB: 'USD to RMB conversion',
    RMBToUSD: 'RMB to USD conversion',
    bucket: 'bucket path',
    childLevel: 'Child level',
    invoice: 'invoice ',
    number: 'number ',
    original: 'original ',
    actual: 'actual ',
    information: 'information ',
    fillIn: 'fill in ',
    submit: 'Submit ',
    click: 'click ',
    subtotal: 'subtotal ',
    settlement: 'settlement ',
    varAmount: 'value-added tax ',
    commission: 'commission ',
    exchangeRate: 'exchange rate ',
    automaticCalculation: 'automatic calculation',
    check: 'check ',
    preview: 'preview ',
    reject: 'reject ',
    reason: 'reason ',
    approve: 'approve ',
    image: 'image ',
    price: 'price ',
    used: 'used ',
    use: ' use ',
    payee: 'payee ',
    template: 'template ',
    consumption: 'consumption ',
    automatic: 'automatic ',
    parent: 'parent ',
    report: 'report ',
    details: 'details ',
    credential: 'credential ',
    situation: 'situation ',
    allocation: 'allocation ',
    owner: 'owner ',
    open:'open ',
    device: 'device ',
    preset: 'preset ',
    cc: 'CC recipient',
    feishu: 'Feishu',
    internal: ' internal ',
    query: ' query ',
    bound: ' bound ',
    application: ' application ',
    separate: ' separate ',
    append: ' append ',
    target: ' target ',
    change: ' change ',
    record: ' record ',
    timeLimit: ' time limit ',
    paymentObligations: ' payment obligations ',
    economize: ' economize ',
    estimatedValue: ' estimated value ',
    proposal: ' proposal ',
    refresh: ' refresh ',
    validity: ' validity ',
    instance: ' instance ',
    database: ' database',
    license: ' license ',
    currentGeneration: 'current generation',
    useRatio: 'use ratio',
    totalCommittedUsage: 'total committed usage',
    consumedAmount: 'consumed amount',
    netSavings: 'net savings',
    expenditure: ' expenditure ',
    costPrice: ' cost price ',
    subscribe: ' subscribe ',
    unusedHours: 'reserved time (unused)',
    totalActualHours: 'reserved time (used)',
    engine: ' engine ',
    deployment: " deployment ",
    reservedHours: 'reserved coverage time',
    onDemandHours: 'time on demand',
    totalRunningHours: 'total running time',
    onDemandCost: 'cost on demand',
    dimensionality: ' dimensionality ',
    file: ' file ',
    sales: ' sales ',
    balance: ' balance ',
    recharge: ' recharge ',
    order:' order ',
    beforeAmount:' balance before recharge ', // 充值前余额
    afterAmount:' balance after recharge ', // 充值后余额
    proof: ' proof ',
    field: ' field ',
    permission: ' permission ',
    directory:' directory ',
    coverage:' coverage',
    usage:' usage',
    bucketName: 'bucket ',
    project:'project',
    sort:'sort',
    center:'center '
  },
  btn:{
    bind: 'bind ',
    unbind: 'unbind ',
    search: 'search ',
    add: 'add ',
    cancel:'cancel ',
    save:'save ',
    update: 'update ',
    delete: 'delete ',
    reset:'reset ',
    register:'register ',
    configure:'configure ',
    send:'send ',
    sync: 'sync ',
    download: ' download ',
    disassociate: 'disassociate ',
    success: 'Operation successful!',
    details: 'details ',
    check: 'check ',
    export: 'export ',
    import: 'import ',
    upload: 'upload ',
    confirm:'confirm ',
    clear:'clear',
    enable:' enable ',
    disable:' disable ',
  },
  home:{
    module1:'Billing system module',
    module2:'Customer business platform',
    module3:'Amazon cloud platform tools',
    module4:'Technical knowledge base',
    module5:'PLS technical support services',
  },
  bill:{
    module1:'Total PayerID',
    module2:'Total LinkID',
    module3:'Total Cost',
    module4:'Total Score',
    module5:'Total Refund',
  },
  sp: {
    basedOnPastData: 'Based on past data',
    first: {
      title: 'Before buying the proposal plan',
      title3: 'On-demand spending is not covered',
      subtitle: 'Value of current monthly on-demand expenditure',
    },
    second: {
      title: 'After purchasing the proposal plan',
      title2: "Equivalent of expenditure on demand",
      title3: "Average coverage ratio",
      subtitle: 'Monthly expenditure estimates'
    },
    third: {
      title2: "Total net savings",
      subtitle: 'Estimated monthly savings'
    },
  },
  ri: {
    first: {
      title: 'General buying advice',
      title2: 'Effective reservation cost',
      title3: 'Total on-demand cost',
    },
    second: {
      title: 'Estimated monthly savings',
      title2: 'On-demand cost equivalent',
      title3: 'Average coverage (hours)'
    },
    third: {
      title: 'Projected savings with on-demand rates',
      title2: 'Total net savings',
      title3: ''
    },
    fourth: {
      title2: 'Total possible cost savings',
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/i18n/config/en.js